import { WEBSOCKETS_UPDATED, NETWORK_STATUS_UPDATED, RECONNECTING_UPDATED } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';

class NetworkConnectionStatusService {
  constructor() {
    this.isWebsocketConnected = true;
    this.isNetworkConnected = true;
    this.registerSchemas();
    this.registerEvents();
    this.initializeValues();
    this.initConnectionListeners();
  }
  initializeValues() {
    window.eventBus.publish(WEBSOCKETS_UPDATED, true);
    window.eventBus.publish(NETWORK_STATUS_UPDATED, true);
  }
  registerEvents() {
    window.eventBus.subscribe(WEBSOCKETS_UPDATED, (e) => {
      this.isWebsocketConnected = e.payload;
      this.publishReconnectingUpdate(this.isWebsocketConnected);
    });
    window.eventBus.subscribe(NETWORK_STATUS_UPDATED, (e) => {
      this.isNetworkConnected = e.payload;
      this.publishReconnectingUpdate(this.isNetworkConnected);
    });
  }
  publishReconnectingUpdate(status) {
    window.eventBus.publish(RECONNECTING_UPDATED, !status);
  }
  registerSchemas() {
    window.eventBus.register(WEBSOCKETS_UPDATED, {
      type: "boolean"
    });
    window.eventBus.register(NETWORK_STATUS_UPDATED, {
      type: "boolean"
    });
    window.eventBus.register(RECONNECTING_UPDATED, {
      type: "boolean"
    });
  }
  initConnectionListeners() {
    const DELAY_MS = 5e3;
    let websocketDelay;
    let networkDelay;
    magic.events.wsDisconnected(() => {
      clearTimeout(websocketDelay);
      websocketDelay = setTimeout(() => {
        window.eventBus.publish(WEBSOCKETS_UPDATED, false);
      }, DELAY_MS);
    });
    magic.events.wsConnected(() => {
      const user = magic.session.getUser();
      if (user) {
        magic.methods.users.subscribeForTags(user);
      }
      clearTimeout(websocketDelay);
      window.eventBus.publish(WEBSOCKETS_UPDATED, true);
    });
    window.addEventListener("offline", () => {
      clearTimeout(networkDelay);
      networkDelay = setTimeout(() => {
        window.eventBus.publish(NETWORK_STATUS_UPDATED, false);
      }, DELAY_MS);
    });
    window.addEventListener("online", () => {
      const user = magic.session.getUser();
      if (user) {
        magic.methods.users.subscribeForTags(user);
      }
      clearTimeout(networkDelay);
      window.eventBus.publish(NETWORK_STATUS_UPDATED, true);
    });
  }
}

export { NetworkConnectionStatusService };
